import React from 'react';
import { useReferentialCache } from './useReferentialCache';

interface ReferentialCacheStatusProps {
  showDetails?: boolean;
  className?: string;
}

export const ReferentialCacheStatus: React.FC<ReferentialCacheStatusProps> = ({
  showDetails = false,
  className = ''
}) => {
  const { cacheStatus, clearCache, refreshCache, formatCacheSize, formatCacheAge } = useReferentialCache();

  if (!showDetails && !cacheStatus.hasCache) {
    return null;
  }

  return (
    <div className={`p-4 border rounded-lg bg-gray-50 ${className}`}>
      <h3 className="text-lg font-semibold mb-2">Cache des Référentiels</h3>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span>Statut:</span>
          <span className={cacheStatus.hasCache ? 'text-green-600' : 'text-red-600'}>
            {cacheStatus.hasCache ? 'Actif' : 'Vide'}
          </span>
        </div>

        {cacheStatus.hasCache && (
          <>
            <div className="flex justify-between">
              <span>Taille:</span>
              <span>{formatCacheSize(cacheStatus.cacheSize)}</span>
            </div>

            <div className="flex justify-between">
              <span>Âge:</span>
              <span className={cacheStatus.isExpired ? 'text-orange-600' : ''}>
                {formatCacheAge(cacheStatus.cacheAge)}
                {cacheStatus.isExpired && ' (expiré)'}
              </span>
            </div>

            <div className="flex justify-between">
              <span>Version:</span>
              <span>{cacheStatus.version}</span>
            </div>
          </>
        )}
      </div>

      <div className="flex gap-2 mt-4">
        <button
          onClick={clearCache}
          className="px-3 py-1 text-sm bg-red-100 text-red-700 rounded hover:bg-red-200"
        >
          Vider le cache
        </button>

        <button
          onClick={refreshCache}
          className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
        >
          Actualiser
        </button>
      </div>
    </div>
  );
};
